
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $666bc8f27f76152a$exports = {};
/*! js-cookie v3.0.5 | MIT */ (function(global, factory) {
    $666bc8f27f76152a$exports = factory();
})($666bc8f27f76152a$exports, function() {
    'use strict';
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    /* eslint-enable no-var */ return api;
});


const $69f9f70c45d9d9c0$var$getElement = (css)=>document.querySelector(css);
const $69f9f70c45d9d9c0$var$getElements = (css)=>document.querySelectorAll(css);
const $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb = {
    MAIN_CITIES: document.querySelectorAll('.main-info__town-name'),
    MAIN_CITY: $69f9f70c45d9d9c0$var$getElement('.main-info__town-name'),
    MAIN_IMG: $69f9f70c45d9d9c0$var$getElement('.main-info__absolute-img'),
    LIKE_CITIES: $69f9f70c45d9d9c0$var$getElement('.right__bottom-town-list'),
    FORM: $69f9f70c45d9d9c0$var$getElement('.header-container'),
    INPUT: $69f9f70c45d9d9c0$var$getElement(".header__input"),
    TEMP: $69f9f70c45d9d9c0$var$getElement(".main-info__degree"),
    BUTTON: {
        LIKE_BTN: $69f9f70c45d9d9c0$var$getElement('.add-favorite-town'),
        SVG_COLOR: $69f9f70c45d9d9c0$var$getElement('.svg-color')
    },
    DETAILS: {
        TEMPERATURE: $69f9f70c45d9d9c0$var$getElement('.temperature'),
        FEELS_LIKE: $69f9f70c45d9d9c0$var$getElement('.feels-like'),
        WEATHER: $69f9f70c45d9d9c0$var$getElement('.weather'),
        SUNRISE: $69f9f70c45d9d9c0$var$getElement('.sunrise'),
        SUNSET: $69f9f70c45d9d9c0$var$getElement('.sunset')
    },
    FORECAST: {
        DAY: $69f9f70c45d9d9c0$var$getElements('.forecast-day'),
        TIME: $69f9f70c45d9d9c0$var$getElements('.forecast-time'),
        TEMPERATURE: $69f9f70c45d9d9c0$var$getElements('.temperature'),
        FEELS_LIKE: $69f9f70c45d9d9c0$var$getElements('.feels-like-forecast'),
        TYPE_WEATHER: $69f9f70c45d9d9c0$var$getElements('.type-of-weather'),
        TYPE_IMG: $69f9f70c45d9d9c0$var$getElements('.type-img-of-weather')
    }
};


function $692890d6b25563b6$export$692d9c3bf53143a5(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
}
function $692890d6b25563b6$export$1f73f60bdb811cb1(key, value) {
    localStorage.setItem(key, value);
}
function $692890d6b25563b6$export$d3720feff416e85b(value) {
    return localStorage.getItem(value);
}




function $8cf650ca14e682d7$export$a3992db8dd0fd9e6(num) {
    return parseInt(num);
}
function $8cf650ca14e682d7$export$b8eba4377ab9904d(cityName) {
    return (0, $54b47fc030b7b21e$export$9011611305877b26).find((item)=>item === cityName);
}



const $84a421994237e1e5$var$IMG_DIR = './assets/';
const $84a421994237e1e5$var$WEATHER_TYPES = {
    'drizzle': 'clouds.png',
    'thunderstorm': 'thunderstorm.png',
    'rain': 'drizzle.png',
    'snow': 'snow.png',
    'mist': 'atmosphere.png',
    'smoke': 'atmosphere.png',
    'haze': 'atmosphere.png',
    'dust': 'atmosphere.png',
    'fog': 'atmosphere.png',
    'sand': 'atmosphere.png',
    'ash': 'atmosphere.png',
    'squall': 'atmosphere.png',
    'tornado': 'atmosphere.png',
    'clear': 'clear.png',
    'clouds': 'clouds.png'
};
function $84a421994237e1e5$var$getWeatherImage(weatherType, weatherIcon) {
    if (weatherIcon.endsWith('n')) return $84a421994237e1e5$var$IMG_DIR + 'night_' + $84a421994237e1e5$var$WEATHER_TYPES[weatherType];
    return $84a421994237e1e5$var$IMG_DIR + $84a421994237e1e5$var$WEATHER_TYPES[weatherType];
}
function $84a421994237e1e5$export$ba35cfff54cbeab4(data) {
    const weatherIcon = data.weather[0].icon;
    const weatherType = data.weather[0].main.toLowerCase();
    return $84a421994237e1e5$var$getWeatherImage(weatherType, weatherIcon);
}


function $d2362592c865fe34$export$59c8628da578fe3e(data, sun) {
    const localTimezoneOffset = new Date().getTimezoneOffset() * 60000;
    const targetTimezoneOffset = data.timezone * 1000 || data.city.timezone * 1000;
    const targetTime = new Date(sun * 1000 + localTimezoneOffset + targetTimezoneOffset);
    return targetTime.toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit'
    });
}
function $d2362592c865fe34$export$9471ed785b17665f(data, date) {
    const localTimezoneOffset = new Date().getTimezoneOffset() * 60000;
    const targetTimezoneOffset = data.city.timezone * 1000;
    const targetTime = new Date(date * 1000 + localTimezoneOffset + targetTimezoneOffset);
    return targetTime.getDate() + ' ' + targetTime.toLocaleString('en', {
        month: 'long'
    });
}


function $902a61401f527680$export$f406504067e3e833(data) {
    (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).TEMP.textContent = (0, $8cf650ca14e682d7$export$a3992db8dd0fd9e6)(data.main.temp) + "\xb0";
    (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).MAIN_CITY.textContent = data.name;
    (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).FORM.reset();
    (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).MAIN_IMG.src = (0, $84a421994237e1e5$export$ba35cfff54cbeab4)(data);
    $902a61401f527680$export$f58f5a0c7e6c8653(data.name);
}
function $902a61401f527680$export$40c5920166934b1d(data) {
    const { temp: temp, feels_like: feels_like } = data.main;
    const weather = data.weather[0].main;
    const { sunrise: sunrise, sunset: sunset } = data.sys;
    (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).DETAILS.SUNSET.textContent = (0, $d2362592c865fe34$export$59c8628da578fe3e)(data, sunset);
    (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).DETAILS.SUNRISE.textContent = (0, $d2362592c865fe34$export$59c8628da578fe3e)(data, sunrise);
    (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).DETAILS.TEMPERATURE.textContent = (0, $8cf650ca14e682d7$export$a3992db8dd0fd9e6)(temp) + "\xb0";
    (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).DETAILS.FEELS_LIKE.textContent = (0, $8cf650ca14e682d7$export$a3992db8dd0fd9e6)(feels_like) + "\xb0";
    (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).DETAILS.WEATHER.textContent = weather;
    (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).MAIN_CITIES.forEach((element)=>{
        element.textContent = data.name;
    });
}
function $902a61401f527680$export$112bde55c0e0e0cb(data) {
    for(let i = 0; i < 5; i++){
        let date = new Date(data.list[i].dt);
        (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).FORECAST.DAY[i].textContent = (0, $d2362592c865fe34$export$9471ed785b17665f)(data, date);
        (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).FORECAST.TIME[i].textContent = (0, $d2362592c865fe34$export$59c8628da578fe3e)(data, date);
        (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).FORECAST.TEMPERATURE[i].textContent = (0, $8cf650ca14e682d7$export$a3992db8dd0fd9e6)(data.list[i].main.temp) + "\xb0";
        (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).FORECAST.FEELS_LIKE[i].textContent = (0, $8cf650ca14e682d7$export$a3992db8dd0fd9e6)(data.list[i].main.feels_like) + "\xb0";
        (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).FORECAST.TYPE_WEATHER[i].textContent = data.list[i].weather[0].main;
        (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).FORECAST.TYPE_IMG[i].style.background = `url(${(0, $84a421994237e1e5$export$ba35cfff54cbeab4)(data.list[i])}) no-repeat`;
        (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).FORECAST.TYPE_IMG[i].style.backgroundSize = '99%';
    }
}
function $902a61401f527680$export$f58f5a0c7e6c8653(cityName) {
    if (!(0, $54b47fc030b7b21e$export$9011611305877b26).has(cityName)) {
        (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).BUTTON.LIKE_BTN.classList.remove('heart');
        (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).BUTTON.LIKE_BTN.classList.add('heart-del');
        (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).BUTTON.SVG_COLOR.setAttribute('stroke', 'black');
        return;
    }
    (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).BUTTON.SVG_COLOR.setAttribute('stroke', 'red');
    (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).BUTTON.LIKE_BTN.classList.remove('heart-del');
    (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).BUTTON.LIKE_BTN.classList.add('heart');
}




async function $563dc8bd7dae6a42$export$8134c072fddab6a5(endpoint, cityName) {
    const serverUrl = "https://api.openweathermap.org/data/2.5";
    const apiKey = "afc9f2df39f9e9e49eeb1afac7034d35";
    const url = `${serverUrl}/${endpoint}?q=${cityName}&units=metric&appid=${apiKey}`;
    try {
        let response = await fetch(url);
        if (response.ok) {
            let data = await response.json();
            if (endpoint === "weather") {
                (0, $902a61401f527680$export$f406504067e3e833)(data);
                (0, $902a61401f527680$export$40c5920166934b1d)(data);
                $563dc8bd7dae6a42$export$8134c072fddab6a5("forecast", data.name);
                (0, (/*@__PURE__*/$parcel$interopDefault($666bc8f27f76152a$exports))).set("lastCity", cityName, {
                    expires: 1,
                    path: ""
                });
            // deleteCookie('lastCity');
            // setCookie('lastCity', cityName, {'max-age': 3600})
            }
            if (endpoint === "forecast") (0, $902a61401f527680$export$112bde55c0e0e0cb)(data);
        } else throw new Error((await response.json()).message);
    } catch (error) {
        alert(error);
    }
}


const $54b47fc030b7b21e$export$9011611305877b26 = new Set();
function $54b47fc030b7b21e$var$getNameCity(event) {
    event.preventDefault();
    let cityName = (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).INPUT.value;
    (0, $563dc8bd7dae6a42$export$8134c072fddab6a5)('weather', cityName);
}
function $54b47fc030b7b21e$var$showCities(cityName) {
    (0, $692890d6b25563b6$export$692d9c3bf53143a5)('favoriteCities', Array.from($54b47fc030b7b21e$export$9011611305877b26));
    (0, $902a61401f527680$export$f58f5a0c7e6c8653)(cityName);
    $54b47fc030b7b21e$var$render();
}
function $54b47fc030b7b21e$var$showEmptyFavoriteList() {
    const li = document.createElement('li');
    const p = document.createElement('p');
    const img = document.createElement('img');
    li.classList.add('rigth__item');
    p.classList.add('empty-cities');
    p.textContent = "Hey, where are all your favorite cities? Looks like it's empty here.";
    img.classList.add('empty-img');
    img.src = './assets/clear.png';
    p.append(img);
    li.append(p);
    (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).LIKE_CITIES.append(li);
}
function $54b47fc030b7b21e$var$addFavoriteCity() {
    const cityName = (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).MAIN_CITY.textContent;
    if ($54b47fc030b7b21e$export$9011611305877b26.has(cityName)) {
        $54b47fc030b7b21e$export$9011611305877b26.delete(cityName);
        $54b47fc030b7b21e$var$showCities(cityName);
        return;
    }
    $54b47fc030b7b21e$export$9011611305877b26.add(cityName);
    $54b47fc030b7b21e$var$showCities(cityName);
}
function $54b47fc030b7b21e$var$removeFavoriteCity(cityName, li) {
    $54b47fc030b7b21e$export$9011611305877b26.delete(cityName);
    (0, $692890d6b25563b6$export$692d9c3bf53143a5)('favoriteCities', Array.from($54b47fc030b7b21e$export$9011611305877b26));
    const mainCityName = (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).MAIN_CITY.textContent;
    (0, $902a61401f527680$export$f58f5a0c7e6c8653)(mainCityName);
    li.classList.remove('rigth__item');
    li.classList.add('del-button-show');
    setTimeout(()=>{
        $54b47fc030b7b21e$var$render();
    }, 550);
}
function $54b47fc030b7b21e$var$createFavoriteCity(item) {
    const li = document.createElement('li');
    const showButton = document.createElement('button');
    const delButton = document.createElement('button');
    showButton.textContent = item;
    li.classList.add('rigth__item');
    showButton.classList.add('show-button');
    delButton.classList.add('delete-button');
    li.append(showButton, delButton);
    showButton.addEventListener('click', ()=>{
        (0, $563dc8bd7dae6a42$export$8134c072fddab6a5)('forecast', item);
        (0, $563dc8bd7dae6a42$export$8134c072fddab6a5)('weather', item);
    });
    delButton.addEventListener('click', ()=>{
        $54b47fc030b7b21e$var$removeFavoriteCity(item, li);
    });
    (0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).LIKE_CITIES.append(li);
}
function $54b47fc030b7b21e$var$render() {
    $54b47fc030b7b21e$export$9011611305877b26.clear();
    const storedFavorites = (0, $692890d6b25563b6$export$d3720feff416e85b)('favoriteCities');
    if (storedFavorites) {
        const parsedFavorites = JSON.parse(storedFavorites);
        parsedFavorites.forEach((item)=>{
            $54b47fc030b7b21e$export$9011611305877b26.add(item);
        });
    }
    document.querySelectorAll('.rigth__item').forEach((element)=>{
        element.remove();
    });
    document.querySelectorAll('.del-button-show').forEach((element)=>{
        element.remove();
    });
    $54b47fc030b7b21e$export$9011611305877b26.forEach((item)=>{
        $54b47fc030b7b21e$var$createFavoriteCity(item);
    });
    if (!$54b47fc030b7b21e$export$9011611305877b26.size) $54b47fc030b7b21e$var$showEmptyFavoriteList();
    (0, $692890d6b25563b6$export$692d9c3bf53143a5)('favoriteCities', Array.from($54b47fc030b7b21e$export$9011611305877b26));
}
(0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).FORM.addEventListener('submit', $54b47fc030b7b21e$var$getNameCity);
(0, $69f9f70c45d9d9c0$export$a6d18b072e3b7ccb).BUTTON.LIKE_BTN.addEventListener('click', $54b47fc030b7b21e$var$addFavoriteCity);
document.addEventListener('DOMContentLoaded', ()=>{
    // const lastCity = getLocalStorage('lastCity') || 'Abu Dhabi';
    // const lastCity = getCookie('lastCity') || 'Abu Dhabi';
    const lastCity = (0, (/*@__PURE__*/$parcel$interopDefault($666bc8f27f76152a$exports))).get('lastCity') || 'Abu Dhabi';
    if (lastCity) {
        (0, $563dc8bd7dae6a42$export$8134c072fddab6a5)('weather', lastCity);
        (0, $563dc8bd7dae6a42$export$8134c072fddab6a5)('forecast', lastCity);
    }
    $54b47fc030b7b21e$var$render();
});


//# sourceMappingURL=darkes.2b3570b1.js.map
